module.exports = __webpack_public_path__ + "static/background-block-e6750e5636590bf20fbd38c5814875b1.jpg";